import styled, { keyframes } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseChevronIcon } from 'assets/images/chevron-bold.svg';
import { ReactComponent as BaseExclamationIcon } from 'assets/images/exclamation-circle-filled.svg';

type ContainerProps = {
  onClick?: () => void;
};

const ripple = keyframes`
  0% {
    box-shadow: 0 4px 10px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 0 rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 5px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 10px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3);
  }
  100% {
    box-shadow: 0 4px 10px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 5px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 10px rgba(${ColorPalette.RGB.GraniteGray2}, 0.3), 0 0 0 20px rgba(${ColorPalette.RGB.GraniteGray2}, 0);
  }
`;

export const Container = styled.div<ContainerProps>`
  position: fixed;
  right: 0;
  z-index: 1000;

  height: 60px;
  max-width: min(60%, 500px);

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${ColorPalette.HEX.CharlestonGreen};
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.2);

  padding: 0 20px;

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  transform: translateX(110%);
  transition: transform 1s ease-in-out;
`;

export const Message = styled.span`
  color: ${ColorPalette.HEX.White};
  font-size: 16px;
  font-weight: 600;

  flex: 1;
  margin: 0 8px;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ExclamationIcon = styled(BaseExclamationIcon)`
  color: ${ColorPalette.HEX.RedRYB};

  border-radius: 100%;
  animation: ${ripple} 1s linear infinite;
`;

export const ChevronIcon = styled(BaseChevronIcon)`
  color: ${ColorPalette.HEX.White};
`;
